import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { toggleOurServiceModal } from "@/reducers/clientcommon";

import { routingConstants } from "../../../../Constants/routingConstants";

const AppliedCalenderRedirectButton = ({
  calDateObj = [],
  btnClass,
  value,
}) => {
  const { candidateDetails } = useSelector(
    (state) => state.clientCandidateDetail,
  );
  const { isPremiumAccount } = useSelector((state) => state.session);
  const dispatch = useDispatch();

  // fetch only date
  const formattedDate = moment(value.$d).format("YYYY-MM-DD") || "";

  // Get the contracts array for the specified date from calDateObj
  const contractsForDate = calDateObj[formattedDate] || [];

  const redirectLink = routingConstants.appliedCandidate; // Define your desired redirect link here

  return (
    <Link
      to={redirectLink}
      state={{
        contractReferenceNo:
          contractsForDate.length > 0
            ? contractsForDate[0].contract_ref_no
            : null,
        candidateReferenceNo: candidateDetails?.reference_no || null,
      }}
      className={`${btnClass} text-black`}
      onClick={(e) => {
        if (!isPremiumAccount) {
          e.preventDefault();
          dispatch(toggleOurServiceModal(true));
          // showManagedServiceToast();
        }
      }}
    >
      <span className={`${btnClass}`}>{value.$D}</span>
    </Link>
  );
};

export default AppliedCalenderRedirectButton;
